import { useEffect } from "react"
import t, { Toaster, useToasterStore } from "react-hot-toast"

export function ToastProvider() {
  const { toasts } = useToasterStore()
  useEffect(() => {
    toasts
      .filter(tt => tt.visible)
      .filter((_, i) => i >= 5)
      .forEach(tt => t.dismiss(tt.id))
  }, [toasts])

  return <Toaster position="bottom-center" toastOptions={{ custom: { icon: null }, duration: 3000 }} containerStyle={{ zIndex: 1000000 }} />
}
